import styled from "styled-components";
import { Layout as AntLayout } from "antd";

const { Content, Footer } = AntLayout;

export const ContentStyled = styled(Content)(({ theme }) => ({
  flexGrow: 1,
  background: theme.secondary,
  minHeight: "calc(100vh - 64px - 70px)",
}));

export const AntLayoutStyled = styled(Content)({
  minHeight: "100vh",
  display: "flex",
  flexDirection: "column",
});

export const FooterStyled = styled(Footer)(({ theme }) => ({
  textAlign: "center",
  background: theme.secondary,
  padding: "16px",
}));
